<template>
  <modal ref="modal" class="product-modal">
    <span slot="activator">
      <slot name="activator"></slot>
    </span>
    <div slot="header">{{ $t('Configure shirt') }}</div>
    <div slot="toolbar" class="ui left aligned">
      <button class="ui button green" @click="$refs.modal.close()">
        {{ $t('Validate') }}
      </button>
    </div>
    <div class="flex">
      <div class="col">
        <h4>{{ $t('Options') }}</h4>
        <div class="scroll cards">
          <parameters-card
            v-for="(options, index) in groups"
            :class="{ active: group_index == index }"
            :key="index"
            :index="index"
            :options="options"
            v-model="group_index"
          ></parameters-card>
        </div>
      </div>
      <div class="col">
        <h4>{{ $t('Parameters') }}</h4>
        <attribute-selector
          :group_index="group_index"
          v-model="attribute_index"
          >{{ group_index }}</attribute-selector
        >
      </div>
      <div class="col">
        <!-- <h4>Value</h4> -->
        <value-selector
          :group_index="group_index"
          :attribute_index="attribute_index"
          :key="group_index"
        >
        </value-selector>
      </div>
    </div>
  </modal>
</template>

<style scoped>
.flex {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
}

.col {
  flex: 1;
  height: 100%;
  padding: 5px;
}

.scroll {
  padding: 5px;
  height: calc(100% - 35px);
  overflow-y: auto;
}
</style>

<script>
import { mapGetters } from 'vuex'

import ParametersCard from '../Designer/ParametersCard'
import AttributeSelector from '../Designer/AttributeSelector'
import ValueSelector from '../Designer/ValueSelector'

export default {
  name: 'ProductModal',
  components: {
    'parameters-card': ParametersCard,
    'attribute-selector': AttributeSelector,
    'value-selector': ValueSelector
  },
  data() {
    return {
      group_index: null,
      attribute_index: null
    }
  },
  computed: {
    ...mapGetters({
      groups: 'getGroups',
      shirt: 'getCurrentShirt'
    })
  },
  watch: {
    shirt() {
      this.group_index = 0
      this.attribute_index = 0
    },
    group_index() {
      this.attribute_index = 0
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
  }
}
</script>



// WEBPACK FOOTER //
// ProductModal.vue?7ba85418